import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ClubLogin from '../components/auth/ClubLogin';
import ClubRegister from '../components/auth/ClubRegister';

const ClubLoginView = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role, loading, signOut, authError, clearAuthError } = useAuth();
  const [currentScreen, setCurrentScreen] = useState('login'); // 'login' | 'register'
  const [loginError, setLoginError] = useState('');
  const [showErrorFromWrongRole, setShowErrorFromWrongRole] = useState(false);

  console.log('[ClubLoginView] render — loading:', loading, 'isAuthenticated:', isAuthenticated, 'role:', role);

  // Cuando el usuario está autenticado con rol incorrecto, cerrar sesión y mostrar error
  useEffect(() => {
    if (!loading && isAuthenticated && role && role !== 'club') {
      signOut().then(() => {
        setShowErrorFromWrongRole(true);
        setLoginError('Correo o contraseña incorrectos. Intenta de nuevo.');
      });
    }
  }, [isAuthenticated, role, loading, signOut]);

  // Solo redirigir si el usuario ES un club autenticado
  if (!loading && isAuthenticated && role === 'club') {
    return <Navigate to="/clubes/dashboard" replace />;
  }

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleGoToRegister = () => {
    setCurrentScreen('register');
  };

  const handleBackToLogin = () => {
    setCurrentScreen('login');
  };

  if (currentScreen === 'register') {
    return (
      <ClubRegister
        onBackToHome={handleBackToHome}
        onBackToLogin={handleBackToLogin}
      />
    );
  }

  // Prioridad del mensaje mostrado en la UI:
  //   1. Error de rol incorrecto (intento de login con cuenta que no es de club)
  //   2. authError persistente del AuthContext (cuenta pendiente/rechazada)
  const forcedError = showErrorFromWrongRole
    ? loginError
    : (authError || '');

  return (
    <ClubLogin
      onBackToHome={handleBackToHome}
      onGoToRegister={handleGoToRegister}
      forcedError={forcedError}
      onErrorDisplayed={() => {
        setShowErrorFromWrongRole(false);
        clearAuthError();
      }}
    />
  );
};

export default ClubLoginView;
